import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "src/components/App";
import { Provider } from "src/components/providers/Provider";
import { reportWebVitals } from "src/utils/reportWebVitals";
import { listenStaleBuildErrors } from "src/utils/staleBuild";
// Стили react-toastify обязательны (v11 их не инжектит) — без них всплывающие
// уведомления (toast) рендерятся без оформления и фактически не видны.
import "react-toastify/dist/ReactToastify.css";

// Ошибки загрузки файлов старой сборки (после выката новой версии) чиним
// автоматической перезагрузкой — иначе пользователь видит белый экран.
listenStaleBuildErrors();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <StrictMode>
    <Provider>
      <App />
    </Provider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
